export const LongDash = () => <span>&#8212;</span>
